{
  "metadata": {
    "id": "osaka-jade-dark",
    "name": "Osaka Jade",
    "description": "Портировано из темы «Osaka Jade» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "osaka-jade.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/osaka-jade.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 22.9,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.459,
      "paletteMaxS": 0.533,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.3,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 24.0,
      "syntaxVsTextMinDeltaE": 23.8,
      "chartsMinDeltaE": 27.9,
      "textSeparationDeltaE": 22.1,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "string",
          "b": "function",
          "deltaE": 6.6
        },
        {
          "a": "string",
          "b": "type",
          "deltaE": 6.6
        },
        {
          "a": "string",
          "b": "operator",
          "deltaE": 13.6
        },
        {
          "a": "function",
          "b": "type",
          "deltaE": 0.0
        },
        {
          "a": "function",
          "b": "operator",
          "deltaE": 9.9
        },
        {
          "a": "type",
          "b": "operator",
          "deltaE": 9.9
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#2DD5B7",
      "hover": "#46dac0",
      "active": "#57ddc5",
      "foreground": "#000000",
      "muted": "#2dd5b780",
      "emphasis": "#2DD5B7"
    },
    "surface": {
      "background": "#111c18",
      "foreground": "#C1C497",
      "muted": "#253027",
      "mutedForeground": "#8ca496",
      "elevated": "#2f392e",
      "elevatedForeground": "#C1C497",
      "raised": "#485141",
      "raisedForeground": "#C1C497",
      "overlay": "#111c18cc",
      "subtle": "#1c2720"
    },
    "interactive": {
      "border": "#4b5442",
      "borderHover": "#424b3c",
      "borderFocus": "#2DD5B7",
      "selection": "#c1c49729",
      "selectionForeground": "#C1C497",
      "focus": "#2dd5b759",
      "focusRing": "#2dd5b761",
      "cursor": "#c1c497",
      "hover": "#c1c4971c",
      "active": "#c1c49729"
    },
    "status": {
      "error": "#FF5345",
      "errorForeground": "#000000",
      "errorBackground": "#ff534524",
      "errorBorder": "#ff534573",
      "warning": "#E5C736",
      "warningForeground": "#000000",
      "warningBackground": "#e5c73624",
      "warningBorder": "#e5c73673",
      "success": "#549e6a",
      "successForeground": "#000000",
      "successBackground": "#549e6a24",
      "successBorder": "#549e6a73",
      "info": "#2DD5B7",
      "infoForeground": "#000000",
      "infoBackground": "#2dd5b724",
      "infoBorder": "#2dd5b773"
    },
    "pr": {
      "open": "#549e6a",
      "draft": "#95aa9d",
      "blocked": "#E5C736",
      "merged": "#549e6a",
      "closed": "#FF5345"
    },
    "syntax": {
      "base": {
        "background": "#333d31",
        "foreground": "#C1C497",
        "comment": "#95aa9d",
        "keyword": "#2DD5B7",
        "string": "#6ab380",
        "number": "#dd8bb3",
        "function": "#6eb282",
        "variable": "#C1C497",
        "type": "#6eb282",
        "operator": "#61b56e"
      },
      "tokens": {
        "commentDoc": "#95aa9d",
        "stringEscape": "#61b56e",
        "keywordImport": "#2DD5B7",
        "storageModifier": "#2DD5B7",
        "functionCall": "#6eb282",
        "method": "#6eb282",
        "variableProperty": "#6eb282",
        "variableOther": "#C1C497",
        "variableGlobal": "#dd8bb3",
        "variableLocal": "#61b56e",
        "parameter": "#C1C497",
        "constant": "#dd8bb3",
        "class": "#6eb282",
        "className": "#6eb282",
        "interface": "#6eb282",
        "struct": "#6eb282",
        "enum": "#6eb282",
        "typeParameter": "#6eb282",
        "namespace": "#6eb282",
        "module": "#2DD5B7",
        "tag": "#2DD5B7",
        "jsxTag": "#2DD5B7",
        "tagAttribute": "#6eb282",
        "tagAttributeValue": "#6ab380",
        "boolean": "#dd8bb3",
        "decorator": "#2DD5B7",
        "label": "#6eb282",
        "regexp": "#6ab380"
      }
    },
    "charts": {
      "series": [
        "#2DD5B7",
        "#2dbbd5",
        "#549e6a",
        "#E5C736",
        "#FF5345"
      ]
    },
    "chat": {
      "background": "#111c18",
      "userMessage": "#C1C497",
      "userMessageBackground": "#2f392e",
      "assistantMessage": "#C1C497",
      "assistantMessageBackground": "#253027",
      "timestamp": "#95aa9d",
      "divider": "#4b5442",
      "typing": "#95aa9d"
    },
    "loading": {
      "spinner": "#2DD5B7",
      "spinnerTrack": "#253027",
      "skeleton": "#253027",
      "shimmer": "#3c4537"
    },
    "tools": {
      "background": "#253027",
      "border": "#4b5442",
      "headerHover": "#3a4436",
      "icon": "#2DD5B7",
      "title": "#C1C497",
      "description": "#95aa9d",
      "edit": {
        "added": "#549e6a",
        "addedBackground": "#549e6a24",
        "removed": "#FF5345",
        "removedBackground": "#ff534524",
        "modified": "#2DD5B7",
        "modifiedBackground": "#2dd5b724",
        "lineNumber": "#95aa9d"
      }
    },
    "markdown": {
      "heading1": "#C1C497",
      "heading2": "#C1C497",
      "heading3": "#C1C497",
      "heading4": "#C1C497",
      "link": "#2DD5B7",
      "linkHover": "#46dac0",
      "inlineCode": "#6ab380",
      "inlineCodeBackground": "#253027",
      "blockquote": "#95aa9d",
      "blockquoteBorder": "#4b5442",
      "listMarker": "#2dd5b7bf",
      "bold": "#C1C497",
      "italic": "#c1c497e6",
      "strikethrough": "#95aa9d",
      "hr": "#4b5442"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#be4555",
        "foreground": "#ffffff",
        "contrast": 5.03
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#d0a38b",
        "foreground": "#000000",
        "contrast": 9.29
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c2864a",
        "foreground": "#000000",
        "contrast": 6.8
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#c7c155",
        "foreground": "#000000",
        "contrast": 11.19
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#b8d38f",
        "foreground": "#000000",
        "contrast": 12.75
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#54c550",
        "foreground": "#000000",
        "contrast": 9.48
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#6bc379",
        "foreground": "#000000",
        "contrast": 9.71
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#59bb9e",
        "foreground": "#000000",
        "contrast": 9.03
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#89cfd8",
        "foreground": "#000000",
        "contrast": 11.98
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4f8fb6",
        "foreground": "#000000",
        "contrast": 5.94
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#486ab2",
        "foreground": "#ffffff",
        "contrast": 5.28
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3841b8",
        "foreground": "#ffffff",
        "contrast": 8.03
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#985ac5",
        "foreground": "#ffffff",
        "contrast": 4.56
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c98ace",
        "foreground": "#000000",
        "contrast": 8.01
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#bf4792",
        "foreground": "#ffffff",
        "contrast": 4.63
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#ce899d",
        "foreground": "#000000",
        "contrast": 7.69
      }
    ]
  }
}
